
export enum AdjustmentType {
    Amount,
    Percentage,
  }


// WEBPACK FOOTER //
// ./src/app/report/enums/adjustment-type.enum.ts